import React from 'react'
import Navbar from "./Navbar";
import Footer from "./Footer";
import './Youtube.css'
import ScrollToTop from "./ScrollToTop";


const Youtube = () => {
  return (
    <div>
    <Navbar />

    <div className='youtube-main'>

        <p>YouTube Business / Fan Page Maintenance</p>

<div className='second-main'>
<div class="row row-cols-1 row-cols-md-3 g-4 second-main2">
<div class="col-lg-4 col-md-6 col-sm-12">
<div class="card">
  <img src="/Imagefile/photo_2024-07-12_16-45-25.jpg" class="card-img-top" height="300" width="200" alt="..."/>
  <div class="card-body">
    <h5 class="youtube-card-title">M.K Oil Mills</h5>
    <p class="card-text"></p>
  </div>
</div>
</div>
<div class="col-lg-4 col-md-6 col-sm-12">
<div class="card">
  <img src="/Imagefile/photo_2024-07-12_16-45-36.jpg" class="card-img-top" height="300" width="200" alt="..."/>
  <div class="card-body">
    <h5 class="youtube-card-title">Vijay Tex</h5>
    <p class="card-text"></p>
  </div>
</div>
</div>
<div class="col-lg-4 col-md-6 col-sm-12">
<div class="card">
  <img src="/Imagefile/photo_2024-07-12_16-44-58.jpg" class="card-img-top" height="300" width="200" alt="..."/>
  <div class="card-body">
    <h5 class="youtube-card-title">Torc Hospital Madurai</h5>
    <p class="card-text"></p>
  </div>
</div>
</div>
{/* <div class="col-lg-4 col-md-6 col-sm-12">
<div class="card">
  <img src="/Facebook - Client/Facebook (4).png" class="card-img-top" height="300" width="200" alt="..."/>
  <div class="card-body">
    <h5 class="youtube-card-title">Senthil Jewellery Mart</h5>
    <p class="card-text"></p>
  </div>
</div>
</div>
<div class="col-lg-4 col-md-6 col-sm-12">
<div class="card">
  <img src="/Facebook - Client/Facebook (5).png" class="card-img-top" height="300" width="200" alt="..."/>
  <div class="card-body">
    <h5 class="youtube-card-title">MK Oil Mill</h5>
    <p class="card-text"></p>
  </div>
</div>
</div>
<div class="col-lg-4 col-md-6 col-sm-12">
<div class="card">
  <img src="/Facebook - Client/Facebook (6).png" class="card-img-top" height="300" width="200" alt="..."/>
  <div class="card-body">
    <h5 class="youtube-card-title">Hi Bro Mens Madurai</h5>
    <p class="card-text"></p>
  </div>
</div>
</div>
<div class="col-lg-4 col-md-6 col-sm-12">
<div class="card">
  <img src="/Facebook - Client/Facebook (7).png" class="card-img-top" height="300" width="200" alt="..."/>
  <div class="card-body">
    <h5 class="youtube-card-title">Varshan Enterprises</h5>
    <p class="card-text"></p>
  </div>
</div>
</div>
<div class="col-lg-4 col-md-6 col-sm-12">
<div class="card">
  <img src="/Facebook - Client/Facebook.png" class="card-img-top" height="300" width="200" alt="..."/>
  <div class="card-body">
    <h5 class="youtube-card-title">Saaral bakes cakes sweets</h5>
    <p class="card-text"></p>
  </div>
</div>
</div> */}
</div>
</div>

</div>
<ScrollToTop />
<Footer />
</div>
  )
}

export default Youtube
